import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    alerts: [],
    alert: {
      name: '',
      message: '',
    },
  },
  mutations: {
    updateAlert(state, claim) {
      state.alert = claim;
    },
    updateAlerts(state, alerts) {
      state.alerts = alerts;
    },
    addAlert(state, user) {
      state.alerts.push(user);
    },
    putAlert(state, alert) {
      state.alerts = state.alerts.map((value) => (alert.id === value.id ? alert : value));
    },
    deleteAction(state, id) {
      state.alerts = state.alerts.filter((alert) => alert.id !== id);
    },
  },
  actions: {

    getAlert({ commit }, id) {
      axiosInstance.get(urlsAPI.alertsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateAlert', response.data);
          }
        })
        .catch(handlerError);
    },

    getAlerts({ commit }) {
      axiosInstance.get(urlsAPI.alertsURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateAlerts', response.data);
          }
        })
        .catch(handlerError);
    },

    createAlert({ commit }, body) {
      axiosInstance.post(urlsAPI.alertsURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('addAlert', response.data);
          }
        })
        .catch(handlerError);
    },

    updateAlert({ commit }, { id, body }) {
      axiosInstance.put(urlsAPI.alertsURL + id, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putAlert', response.data);
          }
        })
        .catch(handlerError);
    },

    delete({ commit }, id) {
      axiosInstance.delete(urlsAPI.alertsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', id);
          }
        })
        .catch(handlerError);
    },
  },
};
